import { useState } from "react";
import { createPortal } from "react-dom";
import { clsx } from "clsx";

import CreateGame from "../modals/CreateGame";
import JoinGame from "../modals/JoinGame";

const root = document.getElementById("root");

function Home() {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showJoinModal, setJoinModal] = useState(false);

	const style = {
		// modal: "mx-auto relative lg:w-1/2 md:w-2/3 w-full lg:h-4/6 h-full lg:my-28 rounded-lg overflow-hidden",
		info: "flex flex-col",
		article: {
			base: "lg:text-lg text-md",
			section: "text-center m-2"
		},
		modal: {
			container: "fixed top-1/2 left-1/2 -translate-1/2 h-9/10 w-full lg:h-4/6 lg:w-1/2 pt-2 flex items-center justify-center text-center bg-blue-200 border-2 border-blue-400 rounded-lg",
			closeContainer: "absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-100 rounded-full cursor-pointer",
			closeIcon: "w-[25px]",
		},
		button: "w-52 px-10 py-3 text-xl font-bold text-white bg-blue-500 rounded-md hover:shadow hover:bg-blue-800 cursor-pointer",
	};

	function closeCreateModal() {
		setShowCreateModal(false)
	}

	function createGame() {
		closeCreateModal();
	}

	function closeJoinModal() {
		setJoinModal(false)
	}

	function joinGame() {
		closeJoinModal();
	}

	return (
		<div className={clsx(
			"h-screen bg-blue-50 overflow-hidden", (showCreateModal || showJoinModal) && "blur-xs"
			)}>
			<h1 className="min-h-[15%] mt-16 lg:text-3xl text-2xl text-center">Tug of Logic: A Philosophy Sports Game</h1>
			<div className="min-h-[55%] flex flex-col items-center justify-center mx-auto gap-4 lg:gap-8 align-middle">
				<article className={style.article.base}>
					<section className={style.article.section}>
						Welcome to Tug of Logic, a competitive and collaborative game for building effective arguments together upon a shifting common-ground.
					</section>
					<section className={style.article.section}>
						To play, you need a group of people assembled together (e.g. in a café or classroom) with Internet connections.
					</section>
				</article>
				<button onClick={() => setShowCreateModal(true)} className={style.button}>
					Create Game
				</button>
				<article className={style.article.base}>
					<section className={style.article.section}>
						A Logic Referee creates the game, players Join a Game.
					</section>
				</article>
				<button onClick={() => setJoinModal(true)} className={style.button}>
					Join Game
				</button>
				<article className={style.article.base}>
					<section className={style.article.section}>
						This web-app is virtual infrastructure for reasoning together.
					</section>
					<section className={style.article.section}>
						To learn how to play, visit <a href="https://www.philosophy-sports.com" target="_blank"  rel="noreferrer" className="underline text-blue-500 cursor-pointer">www.philosophy-sports.com</a>, and watch the explainer there.
					</section>
				</article>
				{showCreateModal && createPortal(
					<CreateGame modalStyle={style.modal} createGame={createGame} closeModal={closeCreateModal} />,
					root
				)}
				{showJoinModal && createPortal(
					<JoinGame modalStyle={style.modal} joinGame={joinGame} closeModal={closeJoinModal} />,
					root
				)}
			</div>
		</div>
	);
}

export default Home;
